import axios, { AxiosResponse } from 'axios';
import {
  CreateCheckupWithCompletedCheckupIdRequest,
  CreateCheckupWithCompletedCheckupIdResponse,
  ItemUploadSignedUrl,
  CheckupRequestInclude,
  CheckupRequestV2Response
} from '@companion-professional/dctypes';
import {
  CHECKUP_REQUEST_URL,
  GENERATE_UPLOAD_URL,
  CREATE_CHECKUP_URL
} from './config';

// This file contains all the API HTTP requests for the application.

// getCheckupRequest is a function that fetches a single checkup request.
export const getCheckupRequest = async (checkupRequestId: string, includeQueryParams: CheckupRequestInclude[]): Promise<CheckupRequestV2Response> => {
  const queryString = includeQueryParams.join(',');
  const fullQueryString = queryString.length === 0 ? '' : `?include=${queryString}`;
  const response = await axios.get<CheckupRequestV2Response>(`${CHECKUP_REQUEST_URL}/${checkupRequestId}${fullQueryString}`);
  return response.data;
};

// getItemUploadUrl is a function that fetches a signed URL for uploading a video to MUX
export const getItemUploadUrl = async (itemId: string): Promise<ItemUploadSignedUrl> => {
  const response = await axios.post<ItemUploadSignedUrl>(`${GENERATE_UPLOAD_URL}/${itemId}`);
  return response.data;
};


// createCheckupFromExistingCheckup creates a new checkup that mirrors an existing one, identified only by its id. The
// server copies the clinic, pet, requesting user, and location tags from the existing checkup, so we only need to send
// the id. Returns the id of the newly created checkup.
export const createCheckupFromExistingCheckup = async (completedCheckupId: string): Promise<string> => {
  const response = await axios.post<
    CreateCheckupWithCompletedCheckupIdResponse,
    AxiosResponse<CreateCheckupWithCompletedCheckupIdResponse>,
    CreateCheckupWithCompletedCheckupIdRequest
  >(CREATE_CHECKUP_URL, {
    completed_checkup_id: completedCheckupId
  });
  return response.data.checkup_id;
};
